import { createRouter, createWebHashHistory } from "vue-router";
//import Home from "@/views/Home";
import Login from "@/components/login";
import Announcements from "@/components/announcements";
import Cleaning from "@/components/cleaning";
import Notice from "@/components/notice";
import Provider from "@/components/provider";
import PageNotFound from "@/components/pagenotfound";
import Profile from "@/components/profile";
import Logout from "@/components/logout";
import Location from "@/components/location";
import User from "@/components/users";

import store from "@/store";

const routes = [
  {
    path: "/cleaning",
    name: "cleaning",
    component: Cleaning,
    meta: { requiresAuth: true, requiresMandate: false }
  },
  {
    path: "/provider",
    name: "provider",
    component: Provider,
    meta: { requiresAuth: true, requiresMandate: true }
  },
  {
    path: "/locations",
    name: "location",
    component: Location,
    meta: { requiresAuth: true, requiresMandate: true }
  },
  {
    path: "/users",
    name: "users",
    component: User,
    meta: { requiresAuth: true, requiresAdministrator: true }
  },
  {
    path: "/announcements",
    name: "announcements",
    component: Announcements,
    meta: { requiresAuth: true }
  },
  {
    path: "/notice",
    name: "notice",
    component: Notice,
    meta: { requiresAuth: true, requiresMandate: false }
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  { path: "/:pathMatch(.*)*", component: PageNotFound }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const authenticated = store.state.isAuthenticated;
  const login_type = store.state.login_type;

  // Not logged into a guarded route?
  if (to.meta.requiresAuth && !authenticated) next({ name: "login" });
  else if (
    to.meta.requiresMandate &&
    authenticated &&
    login_type != "mandate" &&
    login_type != "administrator"
  )
    next({ name: "announcements" });
  // Logged in for an auth route
  else if (to.name == "login" && authenticated) {
    if (login_type == "mandate") next({ name: "cleaning" });
    if (login_type == "administrator") next({ name: "users" });
    else next({ name: "announcements" });
  }
  // Carry On...
  else next();
});

export default router;
